import { render } from "./MainStartOffers.vue?vue&type=template&id=068b09b4&scoped=true"
import script from "./MainStartOffers.vue?vue&type=script&lang=js"
export * from "./MainStartOffers.vue?vue&type=script&lang=js"

import "./MainStartOffers.vue?vue&type=style&index=0&id=068b09b4&scoped=true&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-068b09b4"]])

export default __exports__